import { ISharedSidebarItem } from '../../../../shared/layouts/responsive-nav-bar/shared-sidebar-list/shared-sidebar.interface';
import { INavBarConfigContent } from '../../../../shared/layouts/responsive-nav-bar/nav-bar.interface';

export function getFamilyPortalNavbarConfig (providedNavLabels?: INavBarConfigContent) : { [key:string]: ISharedSidebarItem[] } {
  return {
    main: [
      {
        human: providedNavLabels?.home || defaultNavLabels.home,
        key: 'Home', // key is hardcoded as it should not be translated
        leftDefaultIcon: 'family-portal-home-default',
        leftSelectedIcon: 'family-portal-home-selected',
        leftDefaultIconAriaLabel: providedNavLabels?.home || defaultNavLabels.home,
        leftSelectedIconAriaLabel: providedNavLabels?.home || defaultNavLabels.home,
        url: '/home',
      },
      {
        human: providedNavLabels?.messages || defaultNavLabels.messages,
        key: 'Messages', // key is hardcoded as it should not be translated
        leftDefaultIcon: 'family-portal-message-default',
        leftSelectedIcon: 'family-portal-message-selected',
        leftDefaultIconAriaLabel: providedNavLabels?.messages || defaultNavLabels.messages,
        leftSelectedIconAriaLabel: providedNavLabels?.messages || defaultNavLabels.messages,
        url: '/messages',
      },
      {
        human: providedNavLabels?.myAccount || defaultNavLabels.myAccount,
        key: 'My Account', // key is hardcoded as it should not be translated
        leftDefaultIcon: 'family-portal-gear-default',
        leftSelectedIcon: 'family-portal-gear-selected',
        leftDefaultIconAriaLabel: providedNavLabels?.myAccount || defaultNavLabels.myAccount,
        leftSelectedIconAriaLabel: providedNavLabels?.myAccount || defaultNavLabels.myAccount,
        url: '/myaccount',
      },
    ],
  };
}

export const defaultNavLabels: INavBarConfigContent = {
  home: 'Home',
  messages: 'Messages',
  myAccount: 'My Account',
};
